var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo-basic-card"}},[_c('div',{staticClass:"vx-row",staticStyle:{"padding":"10px"}},_vm._l((_vm.workspaceList),function(space){return _c('spaceItem',{key:space.id,attrs:{"spaceInfo":space}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }